import {useOffersListUrl} from "./use_offers_list_url";
import {useOffersMapUrl} from "./use_offers_map_url";

export function useOffersViewsUrl() {
    const listUrl = useOffersListUrl();
    const mapUrl = useOffersMapUrl();

    return {
        listUrl,
        mapUrl
    };
}
import {useOffersListUrl} from "./use_offers_list_url";
import {useOffersMapUrl} from "./use_offers_map_url";

export function useOffersViewsUrl() {
    const listUrl = useOffersListUrl();
    const mapUrl = useOffersMapUrl();

    return {
        listUrl,
        mapUrl
    };
}
